module.exports = __webpack_public_path__ + "img/carshinaused_06.71063733.jpg";